import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IGuide, IModuleGroup, IModule, ISection, ISelectedModule } from "../models/guide";

@Injectable()
export class GuideService {

  private guideServiceUrl = "./api/employment101";

  constructor(private _http: HttpClient) { }

  get(): Observable<IGuide> {

    return this._http.get<IGuide>(this.guideServiceUrl)
      .pipe(
        map(result => {          

          return result;
        }),
        catchError(this.handleError)
      );
  }

  resetGuide() {
    return this._http.post(this.guideServiceUrl + "/ResetGuide", "").subscribe(res => {
      //nothing
      
    },
      catchError(this.handleError)
    );
  }

  saveGuide(guide: IGuide): Observable<IGuide> {
    return this._http.post<IGuide>(this.guideServiceUrl + "/SaveGuide", guide)
  }

  private handleError(err: HttpErrorResponse) {
    console.log(err);
    console.log(err.message);
    return Observable.throw(err.message);
  }

  CreateGuide(): IGuide {
    let guide = {} as IGuide;
    guide.groups = [];

    //Group 1
    let group1 = {} as IModuleGroup;
    group1.number = 1;
    group1.name = "Prepare a Career Plan";
    group1.sections = [];
    group1.modules = [];

    //1A1
    let sectionA1 = {} as ISection;
    sectionA1.number = 1;
    sectionA1.name = "Explore Careers";
    sectionA1.alpha = "A";
    group1.sections.push(sectionA1);

    let modA1 = {} as IModule;
    modA1.alpha = "A";
    modA1.number = 1;
    modA1.name = "Discover careers that match your interests";
    modA1.complete = false;
    modA1.completed = null;
    modA1.selected = true;
    modA1.activityId = "A11";
    group1.modules.push(modA1);

    let modA2 = {} as IModule;
    modA2.alpha = "A";
    modA2.number = 2;
    modA2.name = "Explore jobs, required skills/credentials, and wage information";
    modA2.complete = false;
    modA2.completed = null;
    modA2.selected = false;
    modA2.activityId = "A21";
    group1.modules.push(modA2);

    let modA3 = {} as IModule;
    modA3.alpha = "A";
    modA3.number = 3;
    modA3.name = "Rank your career options";
    modA3.complete = false;
    modA3.completed = null;
    modA3.selected = false;
    modA3.activityId = "A31";
    group1.modules.push(modA3);

    let modA4 = {} as IModule;
    modA4.alpha = "A";
    modA4.number = 4;
    modA4.name = "Test your knowledge";
    modA4.complete = false;
    modA4.completed = null;
    modA4.selected = false;
    modA4.activityId = "A41";
    group1.modules.push(modA4);

    //1B1
    let sectionB1 = {} as ISection;
    sectionB1.number = 1;
    sectionB1.name = "Explore Training";
    sectionB1.alpha = "B";
    group1.sections.push(sectionB1);

    let modB1 = {} as IModule;
    modB1.alpha = "B";
    modB1.number = 1;
    modB1.name = "Explore training programs";
    modB1.activityId = "B11";

    group1.modules.push(modB1);

    let modB2 = {} as IModule;
    modB2.alpha = "B";
    modB2.number = 2;
    modB2.name = "Rank your training program options";
    modB2.activityId = "B21";
    group1.modules.push(modB2);

    let modB3 = {} as IModule;
    modB3.alpha = "B";
    modB3.number = 3;
    modB3.name = "Research how to pay for training";
    modB3.activityId = "B31";
    group1.modules.push(modB3);

    let modB4 = {} as IModule;
    modB4.alpha = "B";
    modB4.number = 4;
    modB4.name = "Test your knowledge";
    modB4.activityId = "B41";
    group1.modules.push(modB4);

    //1C1
    let sectionC1 = {} as ISection;
    sectionC1.number = 1;
    sectionC1.name = "Get Qualified";
    sectionC1.alpha = "C";
    group1.sections.push(sectionC1);

    let modC1 = {} as IModule;
    modC1.alpha = "C";
    modC1.number = 1;
    modC1.name = "Decide what is needed to reach the job prep level required to achieve your job goal";
    modC1.activityId = "C11";
    group1.modules.push(modC1);

    let modC2 = {} as IModule;
    modC2.alpha = "C";
    modC2.number = 2;
    modC2.name = "Identify your employability skills required for all careers";
    modC2.activityId = "C21";
    group1.modules.push(modC2);

    let modC3 = {} as IModule;
    modC3.alpha = "C";
    modC3.number = 3;
    modC3.name = "Identify your Technical Skills";
    modC3.activityId = "C31";
    group1.modules.push(modC3);

    let modC4 = {} as IModule;
    modC4.alpha = "C";
    modC4.number = 4;
    modC4.name = "Make a plan to reach your goals";
    modC4.activityId = "C41";
    group1.modules.push(modC4);

    let modC5 = {} as IModule;
    modC5.alpha = "C";
    modC5.number = 5;
    modC5.name = "Test your knowledge";
    modC5.activityId = "C51";
    group1.modules.push(modC5);

    guide.groups.push(group1);

    //Group2   
    let group2 = {} as IModuleGroup;
    group2.number = 2;
    group2.name = "Prepare a Job Search Plan";
    group2.sections = [];
    group2.modules = [];

    //2A1
    let sectionA2 = {} as ISection;
    sectionA2.number = 2;
    sectionA2.name = "Get Prepared";
    sectionA2.alpha = "A";
    group2.sections.push(sectionA2);

    let mod2A1 = {} as IModule;
    mod2A1.alpha = "A";
    mod2A1.number = 1;
    mod2A1.name = "Get Organized";
    mod2A1.activityId = "A11";
    group2.modules.push(mod2A1);

    let mod2A2 = {} as IModule;
    mod2A2.alpha = "A";
    mod2A2.number = 2;
    mod2A2.name = "Prepare your resume";
    mod2A2.activityId = "A21";
    group2.modules.push(mod2A2);

    let mod2A3 = {} as IModule;
    mod2A3.alpha = "A";
    mod2A3.number = 3;
    mod2A3.name = "Prepare your portfolio";
    mod2A3.activityId = "A31";
    group2.modules.push(mod2A3);

    let mod2A4 = {} as IModule;
    mod2A4.alpha = "A";
    mod2A4.number = 4;
    mod2A4.name = "Prepare a plan";
    mod2A4.activityId = "A41";
    group2.modules.push(mod2A4);

    let mod2A5 = {} as IModule;
    mod2A5.alpha = "A";
    mod2A5.number = 5;
    mod2A5.name = "Test your Knowledge";
    mod2A5.activityId = "A51";
    group2.modules.push(mod2A5);

    guide.groups.push(group2);

    //2B1
    let sectionB2 = {} as ISection;
    sectionB2.number = 2;
    sectionB2.name = "Find Jobs";
    sectionB2.alpha = "B";
    group2.sections.push(sectionB2);

    let mod2B1 = {} as IModule;
    mod2B1.alpha = "B";
    mod2B1.number = 1;
    mod2B1.name = "Network";
    mod2B1.activityId = "B11";
    group2.modules.push(mod2B1);

    let mod2B2 = {} as IModule;
    mod2B2.alpha = "B";
    mod2B2.number = 2;
    mod2B2.name = "Search for job openings";
    mod2B2.activityId = "B21";
    group2.modules.push(mod2B2);

    let mod2B3 = {} as IModule;
    mod2B3.alpha = "B";
    mod2B3.number = 3;
    mod2B3.name = "Apply for a job";
    mod2B3.activityId = "B31";
    group2.modules.push(mod2B3);

    let mod2B4 = {} as IModule;
    mod2B4.alpha = "B";
    mod2B4.number = 4;
    mod2B4.name = "Interview";
    mod2B4.activityId = "B41";
    group2.modules.push(mod2B4);

    let mod2B5 = {} as IModule;
    mod2B5.alpha = "B";
    mod2B5.number = 5;
    mod2B5.name = "Test your Knowledge";
    mod2B5.activityId = "B51";
    group2.modules.push(mod2B5);

    //Group 3
    let group3 = {} as IModuleGroup;
    group3.number = 3;
    group3.name = "Achieve Your Goals";
    group3.modules = [];
    group3.sections = [];

    let sectionA3 = {} as ISection;
    sectionA3.number = 3;
    sectionA3.name = "Start a Job";
    sectionA3.alpha = "A";
    group3.sections.push(sectionA3);

    let mod3A1 = {} as IModule;
    mod3A1.alpha = "A";
    mod3A1.number = 1;
    mod3A1.name = "Be Prepared to accept the Job";
    mod3A1.activityId = "A11";
    group3.modules.push(mod3A1);

    let mod3A2 = {} as IModule;
    mod3A2.alpha = "A";
    mod3A2.number = 2;
    mod3A2.name = "Get ready for your first day";
    mod3A2.activityId = "A21";
    group3.modules.push(mod3A2);

    let mod3A3 = {} as IModule;
    mod3A3.alpha = "A";
    mod3A3.number = 3;
    mod3A3.name = "Keep your new job";
    mod3A3.activityId = "A31";
    group3.modules.push(mod3A3);

    let mod3A4 = {} as IModule;
    mod3A4.alpha = "A";
    mod3A4.number = 4;
    mod3A4.name = "Test your Knowledge";
    mod3A4.activityId = "A41";
    group3.modules.push(mod3A4);


    //B3
    let sectionB3 = {} as ISection;
    sectionB3.number = 3;
    sectionB3.name = "Financial Literacy";
    sectionB3.alpha = "B";
    group3.sections.push(sectionB3);

    let mod3B1 = {} as IModule;
    mod3B1.alpha = "B";
    mod3B1.number = 1;
    mod3B1.name = "Start up a savings or checking account";
    mod3B1.activityId = "B11";
    group3.modules.push(mod3B1);

    let mod3B2 = {} as IModule;
    mod3B2.alpha = "B";
    mod3B2.number = 2;
    mod3B2.name = "Determine your current financial status and set goals to create monitor and adjust your budget";
    mod3B2.activityId = "B21";
    group3.modules.push(mod3B2);

    let mod3B3 = {} as IModule;
    mod3B3.alpha = "B";
    mod3B3.number = 3;
    mod3B3.name = "Test your Knowledge";
    mod3B3.activityId = "B31";
    group3.modules.push(mod3B3);

    //C3
    let sectionC3 = {} as ISection;
    sectionC3.number = 3;
    sectionC3.name = "Skills for Success";
    sectionC3.alpha = "C";
    group3.sections.push(sectionC3);

    let mod3C1 = {} as IModule;
    mod3C1.alpha = "C";
    mod3C1.number = 1;
    mod3C1.name = "Violence prevention and awareness";
    mod3C1.activityId = "C11";
    group3.modules.push(mod3C1);

    let mod3C2 = {} as IModule;
    mod3C2.alpha = "C";
    mod3C2.number = 2;
    mod3C2.name = "Continue to build your skills";
    mod3C2.activityId = "C21";
    group3.modules.push(mod3C2);

    let mod3C3 = {} as IModule;
    mod3C3.alpha = "C";
    mod3C3.number = 3;
    mod3C3.name = "Volunteer";
    mod3C3.activityId = "C31";
    group3.modules.push(mod3C3);

    let mod3C4 = {} as IModule;
    mod3C4.alpha = "C";
    mod3C4.number = 4;
    mod3C4.name = "Test your Knowledge";
    mod3C4.activityId = "C41";
    group3.modules.push(mod3C4);

    guide.groups.push(group3);

    return guide;
  }

  GetCisUrl(): Observable<string> {
    return this._http.get<string>(this.guideServiceUrl + "/CisUrl")
      .pipe(
        map(result => {

          return result;
        }),
        catchError(this.handleError)
      );
  }
}
